module.exports = __webpack_public_path__ + "static/media/RSVPLogo.333c6f5a.jpg";